import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
// import PDFformat from './PDFformat';
import Header from "./components/Header";
import axios from "axios";
// import PDFExport from './src/PDFExport';
import PDFformat from "./PDFformat";
const ITEMS_PER_PAGE = 10;

const PurchaseOrderlist2 = () => {

  const user = JSON.parse(localStorage.getItem("user"));
let id = null;

if (user?.kitchen) {
  id = user.kitchen;
}

  const [purchaseOrderList, setPurchaseOrderList] = useState([]);
  const [valuExport, setExport] = useState([]);
  const [vendorName, setVendorName] = useState("Anand Kumar");
  const [loading, setLoading] = useState(true);
  const [stockVendors, setStockVendors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({ vendorId: "", date: "" });

  const fetchVendors = async () => {
    try {
      const res = await axios.get(
        "https://ims-backend.indevconsultancy.in/admin-panel/vendor/"
      );
      setStockVendors(res.data || []);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const fetchPurchaseOrders = async (vendorId = "", createdDate = "") => {
    try {
      let url = `https://ims-backend.indevconsultancy.in/api/purchase_orderlist/?kitchen_id=${id}`;
      const params = [];
      if (vendorId) params.push(`vendor_id=${encodeURIComponent(vendorId)}`);
      if (createdDate)
        params.push(`created=${encodeURIComponent(createdDate)}`);
      if (params.length) url += `&${params.join("&")}`;

      const res = await fetch(url);
      const data = await res.json();

      const list = data?.data || [];

      if (list.length > 0) {
        setPurchaseOrderList(list);
        setExport(list);
        setVendorName(list[0].vendor_name || "AN");
      } else {
        setPurchaseOrderList([]);
        setExport([]);
      }
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPurchaseOrders();
    fetchVendors();
  }, []);

  const totalPages = Math.ceil(purchaseOrderList.length / ITEMS_PER_PAGE);
  const currentItems = purchaseOrderList.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e) => {
    e.preventDefault();

    const { vendorId, date } = filters;
    if (!vendorId && !date) return alert("Please select at least one filter");
    fetchPurchaseOrders(vendorId, date);
  };

  const handleReset = () => {
    setFilters({ vendorId: "", date: "" });
    fetchPurchaseOrders();
  };

  const formatDate = (dateString) => {
    if (!dateString || typeof dateString !== "string") return "N/A";

    const cleanedDate = dateString.trim();
    const date = new Date(cleanedDate);

    if (isNaN(date.getTime())) return "N/A"; // invalid date check

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };



  return (
    <>
      <Header />
      <div className="container-fluid px-2">
        {/* <div className="row mt-2">
          <div className="col">
            <span className="fs-1">Purchase Order List</span>
          </div>
          <div className="col">
            <nav className="py-2" aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-end">
                <li className="breadcrumb-item active">Purchase Order List</li>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
        </div> */}
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-8 text-end">
            <span className="fs-1">Purchase Order List</span>
          </div>
        </div>

        <div className="card">
          <div className="card-header border-info">
            <form onSubmit={handleSearch}>
              <p>Kitchen Name</p>
              <div className="row g-3">
                <div className="col-lg">
                  <select
                    className="form-select"
                    value={filters.vendorId}
                    onChange={(e) =>
                      setFilters({ ...filters, vendorId: e.target.value })
                    }
                  >
                    <option value="">Select Vendor</option>
                    {stockVendors.map((vendor) => (
                      <option key={vendor.vendor_id} value={vendor.vendor_id}>
                        {vendor.vendor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg">
                  <input
                    type="date"
                    className="form-control"
                    value={filters.date}
                    onChange={(e) =>
                      setFilters({ ...filters, date: e.target.value })
                    }
                  />
                </div>
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>
                <div className="col-lg-1">
                  <button
                    type="button"
                    className="btn btn-outline-dark w-100"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <h6 className="fw-bold mb-0">
                Total Orders: {currentItems?.length || 0}
              </h6>

              <button
                className="btn btn-primary add-item btn-sm"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#viweModal"
                title="View"
              >
                <i className="fas fa-file"></i>Generate Pdf
              </button>
            </div>

            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Vendor Name</th>
                    <th>Item Name</th>
                    <th>Requested Quantity</th>
                    <th>Approve Quantity</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                        </td>
                        <td>{item.vendor_name}</td>
                        <td>{item.stock_name}</td>
                        <td>{item.requested_quantity}</td>
                        <td>{item.approve_queantity}</td>
                        {/* <td>{item.approval_date}</td>   */}
                        <td>{formatDate(`${item.approval_date}`)}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages || totalPages === 0}
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="viweModal"
          tabIndex="-1"
          aria-labelledby="registerModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-fullscreen-sm-down modal-xl"
            style={{ maxWidth: "95vw" }}
          >
            <div className="modal-content">
              <form>
                <div className="modal-header">
                  <h5 className="modal-title" id="registerModalLabel">
                    View PDF
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div
                  className="modal-body"
                  style={{ overflowX: "auto", paddingBottom: "2rem" }}
                >
                  <div className="container-fluid">
                    <PDFformat data={valuExport} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderlist2;
